export const ENV = window.__PSN_FEEDBACK_ENV__;
